// extracted by mini-css-extract-plugin
export default {"section":"Slogan_section__U-Gxb","container":"Slogan_container__FmxnW","text1":"Slogan_text1__U5G3h","text2":"Slogan_text2__RjoRE"};